import axios from 'axios'

export const getBaseURL = (): string => {
  let baseURL = `${process.env.REACT_APP_API_URL ?? ''}/api`

  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    baseURL = 'http://localhost:3001'
  }

  return baseURL
}

export const getFileURL = (): string => {
  let fileURL = `${window.location.protocol}//files.${window.location.host}/file`

  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    fileURL = 'http://localhost:3001/file'
  }

  return fileURL
}

const setupAxios = () => {
  axios.defaults.baseURL = getBaseURL()
  axios.defaults.withCredentials = true
}

export default setupAxios
